import enviro from 'enviro';

enum ENV {
  PROD = 'PROD',
  QA = 'QA',
}

const EPIC_APP_IDS: Record<ENV, number> = {
  [ENV.QA]: 32764755,
  [ENV.PROD]: 40104170,
};

const getCurrentEnv = (): ENV => (enviro.isQa() ? ENV.QA : ENV.PROD);

export const getEpicAppId = (): number => EPIC_APP_IDS[getCurrentEnv()];

export const isEpicApp = (appId: number): boolean => appId === getEpicAppId();
